//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "ProductCard",

  props: {
    product: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },

  computed: {
    // Костыль для ссылки если подарочный сертификат
    productUrl: function() {
      if (this.product.slug === 'podarochnyj-sertifikat-na-1000-rub-new') {
        return '/sertifikaty'
      } else {
        return this.product.url
      }
    },
    bonusPoints: function () {
      const myAcuvue = this.$store.state?.myacuvue?.profile || {};
      const fittedProducts = myAcuvue?.fitted_products || {};

      if (fittedProducts[this.product?.id]) {
        return fittedProducts[this.product?.id]?.bonuses;
      }

      const product = JSON.parse(JSON.stringify({...this.product}));

      return product?.totalBonusValue || product?.bonus_value_total || "";
    },
    countAdded: function () {
      const carts = this.$store.state?.cart?.items || []
      const product = carts.find((t) => +t.product.id === +this.product.id) || {};

      return product?.quantity || 0;
    },

    categoryLabel: function () {
      return this.product?.category?.name
    },
    bonusPointsLabel: function () {
      if (!this.bonusPoints) {
        return null
      }

      const count = this.bonusPoints;
      const label = this.$caseWords(count, [
        'бонус',
        'бонуса',
        'бонусов',
      ])

      return `+${count} ${label}`
    },
    availableLabel: function () {
      if (this.isNotAvailable || this.product.quantity <= 0) {
        return "Нет в наличии"
      }

      return "В наличии"
    },

    iconWish: function () {
      if (!!this.isInWishlist) {
        return require('../../../../assets/svg/product/wish-fill.svg')
      }

      return require('../../../../assets/svg/product/wish.svg')
    },

    isAddedToCart: function () {
      const carts = this.$store.state?.cart?.items || []
      return Boolean(carts.find((t) => +t.product.id === +this.product.id))
    },
    isShowOldPrice: function () {
      return Boolean(
        !!this.product.price_old &&
        this.product.price_old > this.product.price
      )
    },
    isNotAvailable: function () {
      return this.product.is_not_available || false;
    },
    isInWishlist: function () {
      const wishlist = this.$store.state?.wishlist?.items || []
      return Boolean(wishlist.find((t) => t.id === this.product.id))
    },
    isProductHasModifications: function () {
      return Boolean(
        this.product.has_modifications ||
        this.product.hasModifications
      )
    }
  },

  methods: {

    // Логика работы избранного
    clickWish: async function () {
      if (this.isInWishlist) {
        await this.removeFromWishList(Number(this.product.id))
      } else {
        await this.addToWishList(Number(this.product.id))
      }

      this.$emit('onChangeWish')
    },
    removeFromWishList: async function (productId) {
      this.$store.dispatch('wishlist/removeItem', productId)
    },
    addToWishList: async function (productId) {
      this.$store.dispatch('wishlist/addToWishlist', productId)
    },

    // Добавление товара в корзине
    productAddToCart: async function () {
      if (this.isProductHasModifications) {
        this.fastBuyProduct();

        return null
      }

      const bodyProductAdded = {
        'product_id': this.product.id,
        'quantity': '1'
      }

      this.$store.commit('loading/setLoading', true)

      const responseAddedProducts = await this.$api.agent.transport.post('cart', bodyProductAdded).then((res) => {
        return res.data
      }).catch((err) => {
        return {error: err.response}
      })

      await this.$store.dispatch('cart/getCart')

      this.$store.commit('loading/setLoading', false)

      this.$toast.success('Товар добавлен в корзину')
    },

    // Изменение кол-во товара в корзине
    productChangeCountToCart: async function (type) {
      const carts = this.$store.state?.cart?.items || []
      const product = carts.find((t) => +t.product.id === +this.product.id) || {};

      const url = `cart/${product.id}`;

      const newQuantity = Boolean(type === "+") ? product.quantity + 1 : product.quantity - 1;
      if (newQuantity === 0) {
        await this.productRemoveFromCart(url);

        return;
      }

      const response = await this.$api.agent.transport
        .put(url, {
          quantity: newQuantity,
        })
        .then((res) => {
          return res.data;
        })
        .catch((err) => {
          return {error: err.response};
        });

      if (response.error) {
        const errorData = response.error?.data;

        let errorMessage = '';
        if (Array.isArray(errorData)) {
          errorMessage = (errorData || []).map((t) => t.message).join('; <br/>')
        }
        this.$customNotification.error(errorMessage || "Ошибка изменения количества товара в корзине. Попробуйте позже.");

        return;
      }

      this.updateCartItems();
    },

    // Удаление товара из козины
    productRemoveFromCart: async function (url) {
      const response = await this.$api.agent.transport.delete(url).then((res) => {
        return res.data;
      }).catch((err) => {
        return {error: err.response};
      });
      if (response.error) {
        this.$customNotification.error(
          "Ошибка удаления товара из корзины. Попробуйте позже."
        );

        return;
      }

      this.$yandexCommerce("remove", [{
        ...this.product,
        quantity: 1
      }]);

      this.updateCartItems();
    },

    // Обновление состава корзины
    updateCartItems: function () {
      this.$store.dispatch('cart/getCart')
    },

    // Открытие модального окна добавления в корзину
    fastBuyProduct: function () {
      this.$store.commit("fast-buy/setProductId", this.product.id);
    }

  }
}
